import { render, staticRenderFns } from "./eleDenfence.vue?vue&type=template&id=4fdac48a&scoped=true"
import script from "./eleDenfence.vue?vue&type=script&lang=js"
export * from "./eleDenfence.vue?vue&type=script&lang=js"
import style0 from "./eleDenfence.vue?vue&type=style&index=0&id=4fdac48a&prod&scoped=true&lang=css"
import style1 from "./eleDenfence.vue?vue&type=style&index=1&id=4fdac48a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdac48a",
  null
  
)

export default component.exports